/**
 * Утилиты для операций только на стороне клиента
 * Помогает предотвратить проблемы гидратации между серверным и клиентским рендерингом
 */

import { getErrorMessage } from './error-handler'

// Проверка, выполняется ли код на клиенте
export const isClient = typeof window !== 'undefined';

// Безопасный доступ к localStorage
export const clientStorage = {
  getItem: (key: string): string | null => {
    if (!isClient) return null;
    try {
      return localStorage.getItem(key);
    } catch (error: unknown) {
      console.error('Error accessing localStorage:', getErrorMessage(error));
      return null;
    }
  },
  
  setItem: (key: string, value: string): void => {
    if (!isClient) return;
    try {
      localStorage.setItem(key, value);
    } catch (error: unknown) {
      console.error('Error setting localStorage:', getErrorMessage(error));
    }
  },
  
  removeItem: (key: string): void => {
    if (!isClient) return;
    try {
      localStorage.removeItem(key);
    } catch (error: unknown) {
      console.error('Error removing from localStorage:', getErrorMessage(error));
    }
  }
};

// Безопасный доступ к document / window
export const safeDOM = {
  querySelector: (selector: string): Element | null => {
    if (!isClient) return null;
    return document.querySelector(selector);
  },
  
  getElementsByClassName: (className: string): HTMLCollectionOf<Element> => {
    if (!isClient) return document.getElementsByClassName('');
    return document.getElementsByClassName(className);
  }
};

// Безопасное получение текущего времени (только для клиентской стороны)
export const safeNow = (): number => {
  if (!isClient) return 0;
  return Date.now();
};

// Преобразование относительного пути изображения в полный URL
export const getImageUrl = (path: string | null | undefined): string => {
  if (!path) return '';
  
  // Если путь уже содержит протокол, возвращаем как есть
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  
  // Если путь относительный, добавляем базовый URL API сервера
  if (path.startsWith('/')) {
    const apiUrl = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8081/api';
    // Убираем /api из конца URL и добавляем путь к файлу
    const baseUrl = apiUrl.replace('/api', '');
    return `${baseUrl}${path}`;
  }
  
  return path;
}; 